import { MinervaLogoIcon } from "@minervaproject/fds";
import React, { useState } from "react";
import { useSelector } from "react-redux";

import { LoginStore } from "../store/login";
import { BrandingStore } from "src/store";

const styles = {
  container: {
    alignItems: "start",
    display: "inline-flex",
    height: "146px",
    width: "220px",
  },
  asset: {
    maxHeight: "100%",
    maxWidth: "100%",
  },
};

const Logo = ({ className = "" }) => {
  const [hasError, setHasError] = useState(false);
  const loginDetails = useSelector(LoginStore.selectors.select());
  const branding = useSelector(BrandingStore.selectors.selectAll());
  if (!hasError && loginDetails.org) {
    const orgBranding =
      branding.find((b) => b.org_id === (loginDetails.org && loginDetails.org.value)) || {};
    if (orgBranding.logo_url) {
      return (
        <div style={styles.container} className={className}>
          <img
            style={styles.asset}
            alt={`${loginDetails.org.label} Logo`}
            src={orgBranding.logo_url}
            onError={() => setHasError(true)}
          />
        </div>
      );
    }
  }

  return (
    <div className={className}>
      <MinervaLogoIcon />
    </div>
  );
};

export { Logo };
